export default __webpack_public_path__ + "static/appliances_b.332ab4039a4c4dc8a80f2cc9e18c1570.png";